import CircularProgress from '@mui/material/CircularProgress';
import classes from './TimeandExpensePopup.module.scss';
import MainButton from '../../../buttons/MainButton';
import colors from '../../../../../scss/colors';
import { useWindowSize } from '../../../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../../../utils/constants';
import { buttonVariants } from '../../../buttons/types';

export default function TimeandExpensePopup({
  title,
  primaryButton = {
    text: '',
    action: ''
  },
  secondaryButton = {
    text: '',
    action: ''
  },
  pending = false
}) {
  const { width } = useWindowSize();

  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>{title}</p>
      {primaryButton.text.length ? (
        <MainButton
          rounded
          forceWidth={width > responsiveSizeTimesheet ? '244px' : '100%'}
          action={primaryButton.action}
          variant={buttonVariants.PRIMARY}
        >
          {pending ? <CircularProgress size={20} sx={{ color: colors.WHITE }} /> : primaryButton.text}
        </MainButton>
      ) : null}
      {secondaryButton.text.length ? (
        <MainButton
          rounded
          outlined
          forceWidth={width > responsiveSizeTimesheet ? '244px' : '100%'}
          action={secondaryButton.action}
          variant={buttonVariants.SECONDARY}
        >
          {secondaryButton.text}
        </MainButton>
      ) : null}
    </div>
  );
}
